/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Constants from '../../Config/Config';
import $ from 'jquery';
import Parser from 'html-react-parser';
import ReactPixel from 'react-facebook-pixel';
const ajaxurl = Constants.URL.root+'/wp-admin/admin-ajax.php';
//import CartForm from './CartForm';

export default class SavedItems extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
			cartLoading: false,
			cartContent: null
        }
	    this.addToCart = this.addToCart.bind(this);
  	}

	addToCart() {
		const {savedItems, viewArray} = this.props;

		const cartTotal = savedItems[viewArray].cart1ItemTotal;
		const quantity = savedItems[viewArray].qty;
		const frameTotal = savedItems[viewArray].frameTotal;
		const frameWidth = savedItems[viewArray].frameSizeW;
		const frameHeight = savedItems[viewArray].frameSizeH;
		const item_id = savedItems[viewArray].selectedmatBoard.get('id');
		const product_name = savedItems[viewArray].selectedmatBoard.get('name');

		const canvasImage = savedItems[viewArray].canvasThumbImage;

		const selectedMatSize = savedItems[viewArray].selectedMatSize;

		var selectedTopMat, selectedMiddleMat, middleMatTotal, middleMatGapInCM;

		if (parseFloat(selectedMatSize) !== 0) {
			selectedTopMat = savedItems[viewArray].selectedTopMat.getIn(['title','rendered']);
		}

		if (parseFloat(selectedMatSize) === 2) {
			selectedMiddleMat = savedItems[viewArray].selectedMiddleMat.getIn(['title','rendered']);
			middleMatTotal = savedItems[viewArray].middleMatTotal;
			middleMatGapInCM = savedItems[viewArray].middleMatGapInCM;
		}

		const glassTotal = savedItems[viewArray].glassTotal;
		const selectedGlassName = savedItems[viewArray].selectedGlassName;

		const printTotal = savedItems[viewArray].printTotal;
		const selectedPrintName = savedItems[viewArray].selectedPrintName;

		const frame_id = savedItems[viewArray].selectedFrame.get('id');
		const matBoardWidth = savedItems[viewArray].matBoardWidth;
		const matBoardHeight = savedItems[viewArray].matBoardHeight;
		const matBoardPrice = savedItems[viewArray].matBoardPrice;

  		// Update QTY
  		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				cartQty: parseFloat(quantity) + parseFloat(this.props.cartQty),
				customizeQTY: parseFloat(quantity)
			}
		});
		var self = this;
  		self.setState({cartLoading: true});
  		// Add to cart
		$.ajax(ajaxurl, {
			method: "POST",
			dataType: 'json',
			data: 'action=add_item_to_cart&cartTotal='+cartTotal+'&quantity='+quantity+'&frameTotal='+frameTotal+'&frameWidth='+frameWidth+'&frameHeight='+frameHeight+'&item_id='+item_id+'&product_name='+product_name+'&canvasImage='+canvasImage+'&tMatName='+selectedTopMat+'&mMatName='+selectedMiddleMat+'&mMatTotal='+middleMatTotal+'&mMatVal='+middleMatGapInCM+'&glassName='+selectedGlassName+'&glassTotal='+glassTotal+'&printName='+selectedPrintName+'&printTotal='+printTotal+'&frame_id='+frame_id+'&matBoardWidth='+matBoardWidth+'&matBoardHeight='+matBoardHeight+'&matBoardPrice='+matBoardPrice,
			success: function (res) {
				self.setState({cartContent: res.message, cartLoading: false});
				ReactPixel.track( 'AddToCart' );
			}
		});
  	}

    render() {
    	const {savedItems, viewArray} = this.props;
    	//console.log(savedItems)
        return (
        	<div>
				{savedItems.filter( ( item, key ) =>
					key === parseFloat(viewArray)
					).map( (item) =>
						<div key={item.selectedmatBoard.get('id')} className="viewCompare-wrapper">

			        		{/* <div className="viewCompare-frame-wrapper">
								<img src={item.canvasImage} alt={item.selectedmatBoard.get('name')} />
	    					</div> */}

			        		<div className="popLine">
				        		<div className="col-sm-12">
				        			<label>Layout:</label>
				        			<p>{item.selectedmatBoard.get('name')} ({Constants.Currency + this.props.matBoardPrice})</p>
				        		</div>
			        		</div>

			        		{item.selectedFrame.size > 0 &&
				        		<div className="popLine">
					        		<div className="col-sm-12">
					        			<label>Frame:</label>
					        			<p>{item.selectedFrame.get('name')} ({Constants.Currency + this.props.frameTotal})</p>
					        		</div>
				        		</div>
				        	}

			        		{item.selectedTopMat.size > 0 && parseFloat(item.selectedMatSize) !== 0 &&
				        		<div className="popLine">
					        		<div className="col-sm-12">
					        			<label>Top Mat:</label>
					        			<p>{item.selectedTopMat.getIn(['title', 'rendered'])}</p>
					        		</div>
				        		</div>
			        		}

			        		{item.selectedMiddleMat.size > 0 && parseFloat(item.selectedMatSize) === 2 &&
				        		<div className="popLine">
					        		<div className="col-sm-12">
					        			<label>Middle Mat:</label>
					        			<p>{item.selectedMiddleMat.getIn(['title', 'rendered'])} ({Constants.Currency + this.props.middleMatTotal})</p>
					        		</div>
				        		</div>
			        		}

			        		<div className="popLine">
				        		<div className="col-sm-12">
				        			<label>Glass:</label>
				        			<p>{item.selectedGlassName} ({Constants.Currency + this.props.glassTotal})</p>
				        		</div>
			        		</div>

			        		{item.selectedPrintName !== null &&
				        		<div className="popLine">
					        		<div className="col-sm-12">
					        			<label>Printing:</label>
					        			<p>{item.selectedPrintName} ({Constants.Currency + this.props.printTotal})</p>
					        		</div>
				        		</div>
			        		}

							<div className="popLine">
				        		<div className="col-sm-12">
				        			<label>Quantity:</label>
				        			<p>{item.qty}</p>
				        		</div>
			        		</div>

			        		<div className="popLine">
				        		<div className="col-sm-12">
				        			<label>Total:</label>
				        			<p>{Constants.Currency + item.cart1ItemTotal}</p>
				        		</div>
			        		</div>

			        		<div className="clear"></div>

			        		<div className="row">
			        			<div className="col-sm-12 col-md-4">
			        				<a href="#!" className="btn btn-primary" onClick={this.props.editSaved.bind(this, viewArray)}>Edit</a>
			        			</div>
			        			<div className="col-sm-12 col-md-4">
			        				<a href="#!" className="btn btn-danger" onClick={this.props.deleteArray.bind(this, viewArray)}>Delete</a>
			        			</div>
			        			<div className="col-sm-12 col-md-4">
									<a href="#!" className="btn btn-primary default-btn single_add_to_cart_button" onClick={this.addToCart}>
										{this.state.cartLoading ?
											<div className="loading"></div> :
											<span>Add to cart</span>
										}
									</a>
			        			</div>
			        		</div>
			        	</div>
					)
				}
				{this.state.cartContent !== null &&
					<div className="clear">{Parser(this.state.cartContent)}</div>
				}
			</div>
        );
    }
}